import { asyncEpicStandard } from 'src/logic/helpers/epics/async.epic-helper';
import { registerRequestAccessAsync } from '../register.actions';

export const requestAccessEpic = asyncEpicStandard(
    registerRequestAccessAsync,
    ({ api }, { payload }) => api.register.requestAccess(payload)
);
